import { AppRoutes } from '../../../routes/routeConstants/appRoutes';

export interface HomeService {
  label: string;
  path: string;
  icon: string;
  subtext?: string;
  hasPattern?: boolean;
}

// A summary section renders only when the user has one of these services. Extend with the ids of future summaries.
export const SUMMARY_SERVICE_IDS: ReadonlySet<number> = new Set([1]);

// Keyed by the `id` returned from GET /dashboard/services. Ids without an
// entry here (e.g. MARS Portal) are skipped until their route/icon exist.
export const HOME_SERVICE_PRESENTATION_BY_ID: Record<number, HomeService> = {
  1: {
    label: 'Infrastructure Manager',
    path: AppRoutes.WORK_ORDERS,
    icon: '/assets/infraService.svg',
  },
  2: {
    label: 'Map Portal',
    path: AppRoutes.MAP_PORTAL,
    icon: '/assets/mapService.svg',
    hasPattern: true,
  },
  3: {
    label: 'File Manager',
    path: AppRoutes.ALL_FILES,
    icon: '/assets/fileService.svg',
    subtext: 'Files',
  },
};
